
import { useEffect, useState, useMemo } from "react";
import React from "react";
import { useParams } from "react-router-dom";


import { usePostApi } from "../hooks/post_api_hook/usePostApi";

import VisuelGroupe from "../components/VueGroupe/VisuelGroupe";
import { useClasse } from "../hooks/fetch_api_hook/useClasse";
import Loading from "../components/general/Loading";
import PilotageTabs from "../components/general/PilotageTabs";
import FormGroup from "../components/VueGroupe/FormGroup";
import {useCombinedResults} from "../hooks/fetch_api_hook/useCombinedResults"
import { url } from "../utils/confserveur";
import { useUser } from "../context/UserContext";

// Composition intra-classe : clustering informatif sur les élèves de la classe,
// indépendant des groupes persistés en base (le flux barrette, qui affecte
// réellement des élèves à des groupes, vit dans GroupeBesoinsNiveau/Gniveau).
const LISTE_GROUPES_VIDE = [];

function GroupeBesoins ({selectedBarette}) {
  // Les variables partagé par toute la session (context, lien, navigateur local storage)
    const {idclasse} = useParams();

    const [selectedAutomatismes, setSelectedAutomatismes] = useState([])
    const [selectedProblemes, setSelectedProblemes] = useState([])
   const [selectedLexique, setSelectedLexique] = useState([])
       const [selectedCompetences, setSelectedCompetences] = useState([])
       const [selectedComprehension, setSelectedComprehension] = useState([])
      
    const {etablissementData} = useUser();

    // L'évaluation bilan sélectionné dans la liste déroulante.
    const [selectedEvalBilan, setSelectedEvalBilan] = useState(null)

    // L'évaluation en classe sélectionné dans la liste déroulante.
    const [selectedEvalClasse, setSelectedEvalClasse] = useState(null)

  
    const [nbGroupes , setNbGroupes] = useState(0)


   
    const [typeEval, setTypeEval] = useState("Evaluation Nationale")
    const [listEvalBilan, setListEvalBilan] = useState([])
    const [listEvalClasse, setListEvalClasse] = useState([])

    const[dataGroupe, setDataGroupe] = useState(null)

    const[isSubmit, setIsSubmit] = useState(false)


    const [selectedEval , setSelectedEval] = useState(null)

    const [{data: data_filtered, isLoading: isLoadingPost , isError: isErrorPost }, doPost] = usePostApi(url + "eleves_evaluations_nat/groupes_besoins/");

   const {data : eleves, isLoading} = useClasse(selectedBarette ? `?etablissement_id=${etablissementData.id}&classes_details=${selectedBarette}` : idclasse)


   const listGroupes = LISTE_GROUPES_VIDE;



   const elevesNonAffectes = useMemo(() => {
 
    return eleves?.eleves?.filter(eleve => {
      // Créer une version normalisée du nom et du prénom de l'élève
      const nomCompletEleve = `${eleve.nom.toLowerCase()} ${eleve.prenom.toLowerCase()} ${eleve.id}`;

      // Vérifier si cet élève est présent dans un des groupes
      const estPresentDansUnGroupe = listGroupes.some(groupe => {
        return groupe.eleves.some(eleveGroupe => {
          const nomCompletEleveGroupe = `${eleveGroupe.nom.toLowerCase()} ${eleveGroupe.prenom.toLowerCase()} ${eleve.id}`;
          return nomCompletEleve === nomCompletEleveGroupe;
        });
      });

      // Retourner vrai si l'élève n'est présent dans aucun groupe
      return !estPresentDansUnGroupe;
    });
  }, [eleves, listGroupes]);  // Ajouter eleves et listGroupes comme dépendances
 


 

    useEffect(() => {
      if(eleves.eleves){
          // Objet pour regrouper les évaluations par evalId
  const evaluationsMap = {};

  // Parcourir chaque élève
  eleves.eleves.forEach(eleve => {
    // On regroupe les résultats de l'élève par evalId
    const resultsByEval = {};
    eleve.resultats.forEach(resultat => {
      const evalId = resultat.evalId;
      if (!resultsByEval[evalId]) {
        resultsByEval[evalId] = [];
      }
      resultsByEval[evalId].push(resultat);
    });

    // Pour chaque évaluation pour cet élève, vérifier si ses résultats sont complets
    Object.keys(resultsByEval).forEach(evalId => {
      const resultsForEval = resultsByEval[evalId];
      // On considère les résultats comme complets si, pour cet élève,
      // tous les objets dans resultsForEval ont une propriété "scores" renseignée.
      const isCompleteForThisEleve = resultsForEval.every(r => r.scores !== null && r.scores !== undefined);

      // Si cet élève a tous ses scores complétés pour cette évaluation,
      // alors on l'ajoute comme candidat pour cette évaluation.
      if (isCompleteForThisEleve) {
        if (!evaluationsMap[evalId]) {
          evaluationsMap[evalId] = {
            evalId:  parseInt(evalId,10),
            evalTitre: resultsForEval[0].evalTitre, // On récupère par exemple le titre commun
            candidats: [] // Liste des élèves candidats pour cette évaluation
          };
        }
        evaluationsMap[evalId].candidats.push(eleve);
      }
    });
  });
  // On ne retient que les évaluations pour lesquelles il y a au moins 1 élève candidat
  const listEvals = Object.values(evaluationsMap).filter(evaluation => evaluation.candidats.length > 0);

      setListEvalClasse(listEvals);
      }
    }, [eleves]);

    const elevesParCluster = useMemo(() => {
        // Initialiser un objet pour contenir les élèves organisés par cluster
        const clusters = {};
   
        if (dataGroupe && Array.isArray(dataGroupe)) {
     
         dataGroupe.forEach(eleve => {

          const {  Cluster } = eleve;
       
          let questions = "";

          if(selectedEvalClasse){
            questions = Object.keys(eleve).filter(key => key !== "Cluster" && key !== "id"&& key !== "nom" && key!== "prenom" && key !=="score_obtenu" && key!=="classe_nom");
          }
          else{
            questions = Object.keys(eleve).filter(key => key.endsWith("score"));
          }
          
          // Calculer le score total pour l'élève
          let scoreTotal = questions.reduce((total, current) => {
              return total + eleve[current];
          }, 0) 
        
          // Ajouter le score total à l'objet élève
          eleve.score_obtenu = scoreTotal;
          // Vérifier si le cluster existe déjà dans l'objet clusters
          if (!clusters[Cluster]) {
            clusters[Cluster] = []; // Initialiser le cluster s'il n'existe pas
          }
          // Ajouter l'élève au cluster correspondant
          clusters[Cluster].push(eleve);
        });
                }
        // Assurer que le nombre de clusters dans 'clusters' correspond au nombre de groupes dans 'listGroupes'
        const currentClusterCount = Object.keys(clusters).length;
        const requiredClusterCount = listGroupes.length;

        if (currentClusterCount < requiredClusterCount) {
          // Ajouter des clusters manquants
          for (let i = currentClusterCount; i < requiredClusterCount; i++) {
            clusters[i] = clusters[i] || []; // Créer un nouveau cluster s'il n'existe pas
          }
        }
         // On push tous les eleves absents lors du contrôle dans le dernier cluster.
         let tousLesIdsDesElevesDansClusters;
       
         tousLesIdsDesElevesDansClusters = Object.values(clusters).flatMap(group =>  group.map(eleve =>  eleve.id));
        
         const elevesNonAffectes =  eleves?.eleves?.filter(eleve => !tousLesIdsDesElevesDansClusters.includes(eleve.id));
                   // Trouver l'index du dernier cluster
         const dernierClusterIndex = Object.keys(clusters).length - 1;

         // Ajouter chaque élève non affecté au dernier cluster, un par un
         (clusters.length > 0 && elevesNonAffectes) && Object.values(elevesNonAffectes).forEach(eleve => {
           clusters[dernierClusterIndex].push(eleve);
         });
                    // Supposons que nbGroupes soit le nombre total de groupes que vous voulez afficher
            // (p. ex. 10) et que clusters soit un objet dont les clés sont les numéros de groupe.

            if (currentClusterCount < nbGroupes) {
              for (let i = 0; i < nbGroupes; i++) {
                // On utilise i+1 comme clé pour avoir des clusters 1, 2, 3, ...
                if (!clusters[i]) {
                  clusters[i] = [];
                }
              }
            }
    
        return clusters;
      }, [dataGroupe, listGroupes, nbGroupes, eleves, selectedEvalClasse]);

    
    
    // Utiliser useMemo pour recalculer les labels uniquement si classeNom change

    const labelAutomatismes = useMemo(() => {
      // S'assure que selectedEval et selectedEval.questions sont définis
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
      else{
        evaluation = selectedEvalBilan
      }

      if (!evaluation || !evaluation.questions) {
        return {};
      }
      return evaluation.questions
        .filter(question => question.type_label === "Automatisme")
        .reduce((acc, question) => {
          acc[question.id] = question.nom_label;
          return acc;
        }, {});
    }, [selectedEval, selectedEvalBilan]);
    
    const labelProblèmes = useMemo(() => {
      // S'assure que selectedEval et selectedEval.questions sont définis
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
      else{
        evaluation = selectedEvalBilan
      }
      if (!evaluation || !evaluation.questions) {
        return {};
      }
      return evaluation.questions
        .filter(question => question.type_label === "Résolution de problèmes")
        .reduce((acc, question) => {
          acc[question.id] = question.nom_label;
          return acc;
        }, {});
    }, [selectedEval, selectedEvalBilan]);


    const AutomatismeQuestions = useMemo(() => {
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
      else{
        evaluation = selectedEvalBilan
      }
      if (!evaluation || !evaluation.questions) {
        return {};
      }
      return evaluation.questions
        .filter(question => question.type_label === "Automatisme")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
            ? question.reponses.map(rep => rep.contenu)
            : []; // Fallback sur un tableau vide si ce n'est pas un tableau
          
          acc[question.id] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse
          };
          
          return acc;
        }, {});
    }, [selectedEval, selectedEvalBilan]);
  

    const ProblèmesQuestions = useMemo(() => {
      let evaluation = ""
  
      if(selectedEval){
        evaluation = selectedEval
     
      }
      else{
        evaluation = selectedEvalBilan
       

      }
      
      if (!evaluation || !evaluation.questions) {
        return {};
      }
    
      return evaluation.questions
        .filter(question => question.type_label === "Résolution de problèmes")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
            ? question.reponses.map(rep => rep.contenu)
            : []; // Fallback sur un tableau vide si ce n'est pas un tableau
          
          acc[question.id] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse,
            
          };
          return acc;
        }, {});
    }, [selectedEval, selectedEvalBilan]);



     // Utiliser useMemo pour recalculer les labels uniquement si classeNom change

     const labelAutomatismesNat = useMemo(() => {
      // S'assure que selectedEval et selectedEval.questions sont définis
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
      else{
        evaluation = selectedEvalBilan
      }

      if (!evaluation || !evaluation.questions) {
        return {};
      }
      return evaluation.questions
        .filter(question => question.type_label === "Automatisme")
        .reduce((acc, question) => {
          acc[question.question_num] = question.nom_label;
          return acc;
        }, {});
    }, [selectedEval, selectedEvalBilan]);

    
    const labelProblèmesNat = useMemo(() => {
      // S'assure que selectedEval et selectedEval.questions sont définis
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
      else{
        evaluation = selectedEvalBilan
      }
      if (!evaluation || !evaluation.questions) {
        return {};
      }
      return evaluation.questions
        .filter(question => question.type_label === "Résolution de problèmes")
        .reduce((acc, question) => {
          acc[question.question_num] = question.nom_label;
          return acc;
        }, {});
    }, [selectedEval, selectedEvalBilan]);


    const AutomatismeQuestionsNat = useMemo(() => {
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
      else{
        evaluation = selectedEvalBilan
      }
      if (!evaluation || !evaluation.questions) {
        return {};
      }
      return evaluation.questions
        .filter(question => question.type_label === "Automatisme")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
            ? question.reponses.map(rep => rep.contenu)
            : []; // Fallback sur un tableau vide si ce n'est pas un tableau
          
          acc[question.question_num] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse
          };
          
          return acc;
        }, {});
    }, [selectedEval, selectedEvalBilan]);
  
    const ProblèmesQuestionsNat = useMemo(() => {
  
      let evaluation = ""
      if(selectedEval){
        evaluation = selectedEval
      }
      else{
        evaluation = selectedEvalBilan
      }
      
      if (!evaluation || !evaluation.questions) {
        return {};
      }
      
      return evaluation.questions
        .filter(question => question.type_label === "Résolution de problèmes")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
            ? question.reponses.map(rep => rep.contenu)
            : []; // Fallback sur un tableau vide si ce n'est pas un tableau
          
          acc[question.question_num] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse,
            
          };
          
          return acc;
        }, {});
    }, [selectedEval, selectedEvalBilan]);
    
  const labelLexiqueNat = useMemo(() => {
   let evaluation = selectedEval;
   if (!evaluation || !evaluation.questions) return {};
   
   return evaluation.questions
     .filter(question => question.type_label === "Lexique")
     .reduce((acc, question) => {
       acc[question.question_num] = question.nom_label;
       return acc;
     }, {});
 }, [selectedEval]);
 
 const labelComprehensionEcriteNat = useMemo(() => {
   let evaluation = selectedEval;
   if (!evaluation || !evaluation.questions) return {};
   return evaluation.questions
     .filter(question => question.type_label.startsWith("Compréhension de l'écrit"))
     .reduce((acc, question) => {
       // Extraire le nom du texte (aligné avec ComprehensionEcriteQuestionsNat)
       let texteName = question.type_label.replace("Compréhension de l'écrit ", "");
       if (texteName.startsWith("Document ")) {
         texteName = texteName.replace("Document ", "");
       }
       const key = `${texteName} ${question.question_num}`;
       acc[key] = question.nom_label;
       return acc;
     }, {});
 }, [selectedEval]);
 
 const labelCompetencesLangagieresNat = useMemo(() => {
   let evaluation = selectedEval;
   if (!evaluation || !evaluation.questions) return {};
   
   return evaluation.questions
     .filter(question => question.type_label === "Compétences langagières et linguistiques")
     .reduce((acc, question) => {
       acc[question.question_num] = question.nom_label;
       return acc;
     }, {});
 }, [selectedEval]);
 
 // QUESTIONS FRANÇAIS
 
 const LexiqueQuestionsNat = useMemo(() => {
   let evaluation = selectedEval;
   if (!evaluation || !evaluation.questions) return {};
   
   return evaluation.questions
     .filter(question => question.type_label === "Lexique")
     .reduce((acc, question) => {
       const reponses = Array.isArray(question.reponses)
         ? question.reponses.map(rep => rep.contenu) // Juste le contenu, comme pour les maths !
         : [];
       
       acc[question.question_num] = {
         "question": question.texte,
         "reponses": reponses,
         "image": question.image,
         "bonne_reponse": question.bonne_reponse
       };
       
       return acc;
     }, {});
 }, [selectedEval]);
 
 const ComprehensionEcriteQuestionsNat = useMemo(() => {
   let evaluation = selectedEval;
   if (!evaluation || !evaluation.questions) return {};
   
   return evaluation.questions
     .filter(question => question.type_label.startsWith("Compréhension de l'écrit"))
     .reduce((acc, question) => {
       const reponses = Array.isArray(question.reponses)
         ? question.reponses.map(rep => rep.contenu) // Juste le contenu !
         : [];
       
       // Extraire le nom du texte depuis type_label
       let texteName = question.type_label.replace("Compréhension de l'écrit ", "");
       
       // Si c'est "Document Sommeil", on garde juste "Sommeil"
       if (texteName.startsWith("Document ")) {
         texteName = texteName.replace("Document ", "");
       }
       
       // Créer la clé composite "Arachné Q1" ou "Sommeil Q1"
       const cleComposite = `${texteName} ${question.question_num}`;
       
       acc[cleComposite] = {
         "question": question.texte,
         "reponses": reponses,
         "image": question.image,
         "bonne_reponse": question.bonne_reponse,
         "question_num": question.question_num
       };
       
       return acc;
     }, {});
 }, [selectedEval]);
 
 const CompetencesLangagieresQuestionsNat = useMemo(() => {
   let evaluation = selectedEval;
   if (!evaluation || !evaluation.questions) return {};
   
   return evaluation.questions
     .filter(question => question.type_label === "Compétences langagières et linguistiques")
     .reduce((acc, question) => {
       const reponses = Array.isArray(question.reponses)
         ? question.reponses.map(rep => {
             const responseObj = { contenu: rep.contenu };
             if (rep.image) {
               responseObj.image = rep.image;
             }
             return responseObj;
           })
         : [];
       
       acc[question.question_num] = {
         "question": question.texte,
         "reponses": reponses,
         "image": question.image,
         "bonne_reponse": question.bonne_reponse
       };
       
       return acc;
     }, {});
 }, [selectedEval]);

    const handleSubmit = async (bool) => {
      if(bool){
        
        // Filtrer les résultats pour chaque élève
      const filteredEleves = eleves.eleves.map(eleve => {
        const filteredResults = eleve.resultats.filter(resultat => resultat.evalId ===  selectedEvalClasse.evalId);
        return {
          id: eleve.id,
          nom: eleve.nom,
          classe_nom : '',
          prenom: eleve.prenom,
          resultats: filteredResults
        };
      });
     
      
   
  // Envoyer les données avec une clé, par exemple 'eleves'
  const payload = { eleves: filteredEleves , nb_groupes: nbGroupes};
      await doPost(payload);
      }
      else {
        const payload = {
          classeId: idclasse,
          automatismes: selectedAutomatismes,
          problemes: selectedProblemes,
          lexique : selectedLexique,
          competences : selectedCompetences,
          comprehension: selectedComprehension,
          count: (selectedAutomatismes?.length + selectedProblemes?.length) || (selectedLexique?.length + selectedComprehension?.length) || selectedCompetences?.length,
          nb_groupes : nbGroupes,
          qautomatismes:  AutomatismeQuestionsNat,
          qproblemes :  ProblèmesQuestionsNat,
          qlexique : LexiqueQuestionsNat,
          qcomprehension : ComprehensionEcriteQuestionsNat,
          qcompetences: CompetencesLangagieresQuestionsNat,
          titre : selectedEvalBilan ? selectedEvalBilan.titre : "Evaluation Nationale",
        };
        await doPost(payload);
      }

    }



    const handleAutomatismesChange  = ( selectedOptions) => {
        setSelectedAutomatismes(selectedOptions.map(option => option.value))
    } 

    const handleProblemesChange  = ( selectedOptions) => {
        setSelectedProblemes(selectedOptions.map(option => option.value))
    } 
       const handleLexiqueChange = (selectedOptions) => {
      setSelectedLexique(selectedOptions.map(option=> option.value))
    }
    const handleCompetencesChange = (selectedOptions) => {
      setSelectedCompetences(selectedOptions.map(option=> option.value))
    }
    const handleComprehensionChange = (selectedOptions) => {
      setSelectedComprehension(selectedOptions.map(option=> option.value))
    }
    const handleNbGroupeChange = (e) => {
       setNbGroupes(e.target.value)
    }

    const handleTypeEvalChange = (e,evalnat) => {
      setListEvalBilan(evalnat?.filter(e => 
        e.titre !== "Evaluation Nationale" && 
        e.classe === parseInt(idclasse, 10) &&
        e.eleves_reponses.some(eleve => eleve.reponses)
      ))
      setSelectedAutomatismes([])
      setSelectedProblemes([])
      Object.keys(listGroupes).length === 0 ? setNbGroupes(null) : setNbGroupes(Object.keys(listGroupes).length)
      setTypeEval(e.target.value)
      setSelectedEval(null)
      setSelectedEvalClasse(null)
      setSelectedEvalBilan(null)
   
    }

    const handleNationalEval = (e,evalnat) => {
      setSelectedEvalClasse(null)
      setSelectedEvalBilan(null)
      setSelectedAutomatismes([])
      setSelectedProblemes([])
      Object.keys(listGroupes).length === 0 ? setNbGroupes(null) : setNbGroupes(Object.keys(listGroupes).length)
      setTypeEval(e.target.value)
      setSelectedEval(evalnat.find(evaluation => evaluation.titre ==="Evaluation Nationale"));
    }

    const handleEvalBilanChange = (event) => {
      // Récupère la valeur de l'option sélectionnée
      const selectedTitre = event.target.value;
      setSelectedEvalBilan(listEvalBilan.find(e => e.titre === selectedTitre )); // Ou e.titre

    };

    const handleEvalClasseChange = (event) => {
      setSelectedEvalClasse(listEvalClasse.find(e => e.evalTitre === event.target.value))
    }


    useEffect(() => {
        if (!isLoadingPost && !isErrorPost && data_filtered) {
            const cleanData = data_filtered.replace(/NaN/g, 'null'); // Remplace NaN par null
            try {
                const parsedData = JSON.parse(cleanData);
               
                setDataGroupe(parsedData);
                setIsSubmit(true);
              } catch (error) {
                console.error('Erreur lors de l\'analyse de data_filtered:', error);
              }  
          // Ici, vous pouvez manipuler 'data' comme vous le souhaitez
        }
      }, [isLoadingPost, isErrorPost, data_filtered,eleves]); // Ces dépendances déclenchent l'effet à chaque changement


      
      if(isLoadingPost){
        return <Loading loadingText={"Chargement du loading post"} /> 
      }
     if(isLoading){
      return <Loading loadingText={"Chargement des classes..."} />
     }
  else  {
  return (
    <div>
    <PilotageTabs />
    <div className="pilotage-enter">

       { !isSubmit   ?
   <FormGroup  handleNationalEval={handleNationalEval} typeEval = {typeEval} handleAutomatismesChange={handleAutomatismesChange}
    handleProblemesChange={handleProblemesChange} labelAutomatismes={labelAutomatismes} labelAutomatismesNat={labelAutomatismesNat}
    labelProblèmes={labelProblèmes} labelProblèmesNat={labelProblèmesNat} 
     labelLexiqueNat={labelLexiqueNat} handleLexiqueChange={handleLexiqueChange} selectedLexique={selectedLexique}
    labelCompetencesLangagieresNat={labelCompetencesLangagieresNat} handleCompetencesChange={handleCompetencesChange} selectedCompetences={selectedCompetences}
    labelComprehensionEcriteNat={labelComprehensionEcriteNat} handleComprehensionChange={handleComprehensionChange} selectedComprehension={selectedComprehension}
    handleNbGroupeChange={handleNbGroupeChange}
    selectedAutomatismes={selectedAutomatismes} selectedProblemes={selectedProblemes} listGroupes={[]} listEvalBilan={listEvalBilan}
    selectedEvalBilan={selectedEvalBilan} handleEvalBilanChange={handleEvalBilanChange }nbGroupes={nbGroupes} handleSubmit={handleSubmit} handleTypeEvalChange={handleTypeEvalChange}
    elevesNonAffectes={elevesNonAffectes}
    
     listEvalClasse={listEvalClasse} handleEvalClasseChange={handleEvalClasseChange}
      selectedEvalClasse={selectedEvalClasse}  /> 

        :
            <VisuelGroupe elevesParCluster={elevesParCluster} selectedAutomatismes={selectedAutomatismes} selectedProblemes={selectedProblemes} 
            labelAutomatismes={ selectedEvalBilan ? labelAutomatismes : labelAutomatismesNat} labelProblèmes={ selectedEvalBilan ? labelProblèmes : labelProblèmesNat}
             selectedLexique={selectedLexique}  selectedComprehension={selectedComprehension}
            labelLexiqueNat={labelLexiqueNat} labelComprehensionEcriteNat={labelComprehensionEcriteNat}
            selectedCompetences={selectedCompetences} labelCompetencesLangagieresNat={labelCompetencesLangagieresNat}
            listGroupes={listGroupes} eleves={eleves} 
           selectedEvalClasse={selectedEvalClasse} setIsSubmit={setIsSubmit}
            />
}

    </div>
    </div>

  )
}
}

export default GroupeBesoins;